import { getFunnelsRoutePaths } from 'utils/routes'

export const FETCH_DISCOUNT_PATHS = [
  ...getFunnelsRoutePaths('discountReveal'),
  ...getFunnelsRoutePaths('namePitch'),
]
